// test2562
(2562 && 0);
